import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const getSingleSurveyAction = createAsyncThunk(
    'get-single-survey',
    async (data = null, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/get-single-survey/${data}`,)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const getSingleSurveySlice = createSlice({
    name: 'get-single-survey',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(getSingleSurveyAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(getSingleSurveyAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(getSingleSurveyAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const getSingleSurveyReducer = getSingleSurveySlice.reducer    